var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	85730: () => (loadSingletonVersion("default", "@angular/common", false, [2,21,2,17], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	69776: () => (loadSingletonVersion("default", "@angular/core", false, [2,21,2,17], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	89640: () => (loadSingletonVersion("default", "rxjs", false, [2,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	74464: () => (loadSingletonVersion("default", "rxjs/operators", false, [2,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	8332: () => (loadSingletonVersion("default", "@angular/common/http", false, [2,21,2,17], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	54288: () => (loadSingletonVersion("default", "@angular/forms", false, [2,21,2,17], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0").then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	47939: () => (loadSingletonVersion("default", "@angular/material/autocomplete", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_autocomplete_mjs-_d4db0").then(() => (() => (__webpack_require__(/*! @angular/material/autocomplete */ 79771))))))),
	30651: () => (loadSingletonVersion("default", "@angular/material/core", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_core_mjs-_90eb0").then(() => (() => (__webpack_require__(/*! @angular/material/core */ 74646))))))),
	37879: () => (loadSingletonVersion("default", "@angular/material/datepicker", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_datepicker_mjs-_f7480").then(() => (() => (__webpack_require__(/*! @angular/material/datepicker */ 61977))))))),
	58503: () => (loadSingletonVersion("default", "@angular/material/form-field", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_form-field_mjs-_1aed0").then(() => (() => (__webpack_require__(/*! @angular/material/form-field */ 24950))))))),
	81087: () => (loadSingletonVersion("default", "@angular/material/icon", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_icon_mjs-_bb190").then(() => (() => (__webpack_require__(/*! @angular/material/icon */ 93840))))))),
	82587: () => (loadSingletonVersion("default", "@angular/material/input", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_input_mjs-_34bc0").then(() => (() => (__webpack_require__(/*! @angular/material/input */ 95541))))))),
	62035: () => (loadSingletonVersion("default", "@angular/material/list", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_list_mjs-_3eb00").then(() => (() => (__webpack_require__(/*! @angular/material/list */ 20943))))))),
	68915: () => (loadSingletonVersion("default", "@angular/material/select", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_select_mjs-_b9180").then(() => (() => (__webpack_require__(/*! @angular/material/select */ 25175))))))),
	69771: () => (loadSingletonVersion("default", "@angular/material/table", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_table_mjs-_9ed60").then(() => (() => (__webpack_require__(/*! @angular/material/table */ 77697))))))),
	29091: () => (loadSingletonVersion("default", "@angular/material/tabs", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_tabs_mjs-_b9230").then(() => (() => (__webpack_require__(/*! @angular/material/tabs */ 38223))))))),
	19889: () => (loadSingletonVersion("default", "@angular/material/toolbar", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_toolbar_mjs-_25670").then(() => (() => (__webpack_require__(/*! @angular/material/toolbar */ 39552))))))),
	1801: () => (loadSingletonVersion("default", "@angular/material/tooltip", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_tooltip_mjs-_e18c0").then(() => (() => (__webpack_require__(/*! @angular/material/tooltip */ 80640))))))),
	63926: () => (loadSingletonVersion("default", "@angular/router", false, [2,21,2,17], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a221").then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	32668: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop", false, [2,21,2,17], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f1").then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))))),
	3470: () => (loadSingletonVersion("default", "@azure/msal-browser", false, [1,4,28,1], () => (__webpack_require__.e("node_modules_azure_msal-browser_dist_index_mjs-_29931").then(() => (() => (__webpack_require__(/*! @azure/msal-browser */ 74102))))))),
	86843: () => (loadSingletonVersion("default", "@azure/msal-angular", false, [1,4,0,25], () => (__webpack_require__.e("node_modules_azure_msal-angular_fesm2020_azure-msal-angular_mjs-_6c4a0").then(() => (() => (__webpack_require__(/*! @azure/msal-angular */ 8653))))))),
	21834: () => (loadSingletonVersion("default", "@ngrx/store", false, [2,21,1,1], () => (__webpack_require__.e("node_modules_ngrx_store_fesm2022_ngrx-store_mjs-_da111").then(() => (() => (__webpack_require__(/*! @ngrx/store */ 81383))))))),
	36973: () => (loadSingletonVersion("default", "@angular/material/expansion", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_expansion_mjs-_0cfc0").then(() => (() => (__webpack_require__(/*! @angular/material/expansion */ 19322))))))),
	90587: () => (loadSingletonVersion("default", "@ngrx/effects", false, [2,21,1,1], () => (__webpack_require__.e("node_modules_ngrx_effects_fesm2022_ngrx-effects_mjs-_56480").then(() => (() => (__webpack_require__(/*! @ngrx/effects */ 70347))))))),
	44509: () => (loadSingletonVersion("default", "@angular/material/radio", false, [2,21,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_radio_mjs-_996c0").then(() => (() => (__webpack_require__(/*! @angular/material/radio */ 53804))))))),
	45228: () => (loadSingletonVersion("default", "@angular/core/primitives/di", false, [2,21,2,17], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives-di_mjs-_d1bd0").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))))),
	64506: () => (loadSingletonVersion("default", "@angular/core/primitives/signals", false, [2,21,2,17], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives-signals_mjs-_767e1").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"projects_aic_src_bootstrap_ts": [
		85730,
		69776,
		89640,
		74464,
		8332,
		54288,
		47939,
		30651,
		37879,
		58503,
		81087,
		82587,
		62035,
		68915,
		69771,
		29091,
		19889,
		1801,
		63926,
		32668,
		3470,
		86843,
		21834,
		36973,
		90587,
		44509
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		69776,
		74464,
		89640
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		69776,
		89640
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0": [
		45228,
		64506,
		74464,
		89640
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		89640,
		64506,
		45228,
		74464
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1": [
		69776,
		74464,
		85730,
		89640
	],
	"node_modules_angular_material_fesm2022_autocomplete_mjs-_d4db1": [
		69776,
		89640,
		74464,
		85730,
		8332,
		54288
	],
	"node_modules_angular_material_fesm2022_core_mjs-_90eb1": [
		69776,
		89640,
		74464,
		85730
	],
	"node_modules_angular_material_fesm2022_datepicker_mjs-_f7481": [
		69776,
		89640,
		74464,
		85730,
		8332,
		54288
	],
	"node_modules_angular_material_fesm2022_expansion_mjs-_0cfc1": [
		69776,
		89640,
		74464,
		85730
	],
	"node_modules_angular_material_fesm2022_form-field_mjs-_1aed1": [
		69776,
		85730,
		89640,
		74464
	],
	"node_modules_angular_material_fesm2022_icon_mjs-_bb191": [
		69776,
		89640,
		74464,
		8332,
		85730
	],
	"node_modules_angular_material_fesm2022_input_mjs-_34bc1": [
		69776,
		85730,
		89640,
		74464,
		54288
	],
	"node_modules_angular_material_fesm2022_list_mjs-_3eb01": [
		69776,
		85730,
		89640,
		74464,
		54288
	],
	"node_modules_angular_material_fesm2022_radio_mjs-_996c1": [
		69776,
		89640,
		74464,
		85730,
		54288
	],
	"node_modules_angular_material_fesm2022_select_mjs-_b9181": [
		69776,
		89640,
		74464,
		85730,
		8332,
		54288
	],
	"node_modules_angular_material_fesm2022_table_mjs-_9ed61": [
		69776,
		89640,
		74464,
		85730
	],
	"node_modules_angular_material_fesm2022_tabs_mjs-_b9231": [
		69776,
		89640,
		74464,
		85730
	],
	"node_modules_angular_material_fesm2022_toolbar_mjs-_25671": [
		69776,
		85730
	],
	"node_modules_angular_material_fesm2022_tooltip_mjs-_e18c1": [
		74464,
		69776,
		85730,
		89640,
		8332
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a220": [
		8332,
		69776,
		74464,
		85730,
		89640
	],
	"node_modules_azure_msal-angular_fesm2020_azure-msal-angular_mjs-_6c4a1": [
		69776,
		3470,
		89640,
		85730,
		74464,
		63926
	],
	"node_modules_ngrx_effects_fesm2022_ngrx-effects_mjs-_56481": [
		89640,
		74464,
		69776,
		21834
	],
	"node_modules_ngrx_store_fesm2022_ngrx-store_mjs-_da110": [
		32668,
		69776,
		74464,
		89640
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4621": [
		89640
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		8332
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f1": [
		45228,
		64506
	],
	"node_modules_ngrx_store_fesm2022_ngrx-store_mjs-_da111": [
		32668
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}